import axiosClient from "../axios-config";

export default {
  getCredits(userId) {
    return axiosClient.get("/credit", { params: { user_id: userId }});
  }
}